import React from 'react';
import './Questions.css';

const Questions = ({
    correctAnswer,
    className,
    showAnswers,
    selectedAnswer,
    currentScore,
    totalQuestions,
    currentIndex,
    handleAnswer,
    handleNextQuestion,
    handleSeeCorrectAnswer,
    showAdditionalInfo,
    showAnswerClassName,
    data: { question, correct_answer, answers, additional_info },
}) => {

    let showAnswerClass = showAnswerClassName ? 'btn-showanswer' : 'btn-hide-showanswer';

    return (
        <div className='game' >
            <div id='hud'>
                <div className='hud-item'>
                    <p className='hud-prefix' >Question: </p>
                    <h3 className='hud-main-text' >{currentIndex} / {totalQuestions} </h3></div>
                <div className='hud-item'>
                    <p className='hud-prefix' >Score: </p>
                    <h3 className='hud-main-text' >{currentScore} </h3>
                </div>
            </div>
            <div> <h2 className='question' dangerouslySetInnerHTML={{ __html: question }} /></div>

            <div id='choices' className='choice-container'>
                {answers.map((answer, idx) => {

                    const bgColor = correctAnswer ? correct_answer === answer ? 'btn-choice-correct' : 'btn-choice'
                        : 'btn-choice'
                    const btnClass = (selectedAnswer === answer && correctAnswer === false) ? className : bgColor
                    return (
                        <div>
                            <div className='row'>
                                <div className='col'>
                                    <button
                                        key={idx}
                                        className={btnClass}
                                        onClick={() => handleAnswer(answer)} >
                                        {answer}
                                    </button>
                                </div>
                            </div>
                        </div>
                    )
                })
                }
                <div>
                    {showAdditionalInfo && (
                        <div> <h2 className='additional-info' dangerouslySetInnerHTML={{ __html: additional_info }} /></div>
                    )
                    }
                </div>
            </div>

            {/* only shows when you click on Questionaire */}
            {showAnswers && (
                <div className='btn-grp'>
                    {(correct_answer !== selectedAnswer) &&
                        <div className='col'>
                            <div>
                                <button
                                    onClick={handleSeeCorrectAnswer}
                                    className={showAnswerClass}
                                > Show Answer</button>
                            </div>
                        </div>
                    }

                    <div className='col'>
                        <button
                            onClick={handleNextQuestion}
                            className={'btn-next'}
                        > NEXT </button>
                    </div>
                </div>

            )}


        </div >


    )

};


export default Questions;